import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('FleetFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getFleetList: function () {
            return $http.get(settings.ApiURL + settings.FleetURL);
        },
        getFleetByID: function (id) {
            return $http.get(settings.ApiURL + settings.FleetURL + "/" + id);
        },
        saveFleet: function (Fleet) {
            return $http.put(settings.ApiURL + settings.FleetURL, Fleet);
        },
        deleteFleet: function (id) {
            return $http.delete(settings.ApiURL + settings.FleetURL + "/" + id);
        },        
        getNewFleet: function () {
            return $http.get(settings.ApiURL + settings.FleetURL + "/newfleet");
        }
    };
}]);

app.controller('FleetController', function ($q, $scope, FleetFactory, $rootScope, settings, masterFactory) {
    $rootScope.pageTitle = "Fleet Management";
    $scope.fleetList = [];
    $scope.fleet = {};    
    $scope.newfleet = {};
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.isNewFleet = false;
    $scope.isAssignedVehicleSelected = false;
    $scope.isUnassignedVehicleSelected = false;
    $scope.isAssignedDriverSelected = false;
    $scope.isUnassignedDriverSelected = false;
    // Initialization - this runs on load
    var init = function (pageIndex) {
        masterFactory.verifyAuthentication();

        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([
            FleetFactory.getFleetList().success(function (data) {
                $scope.fleetList = data;
                $scope.refreshGrid(pageIndex);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            })
        ]).then(function () {
            
        });
    };

    var getFleetDetails = function (id) {
        FleetFactory.getFleetByID(id).success(function (data) {
            $scope.fleet = data;
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        });
    };

    init(0);

    // Grid renderers
    $scope.refreshGrid = function (PageIndex) {
        $('#gridFleet').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.fleetList,
                    type: 'array',
                    key: 'Id'
                }
            },
            columns: [
               { alignment: 'center', caption: 'Fleet ID', dataField: 'Id', cssClass: 'Id', dataType: 'number', },
               {
                   alignment: 'center', caption: 'Fleet Name', dataField: 'Name', cssClass: 'Name', dataType: 'string',
                   cellTemplate: function (container, options) {
                       $('<span />')
                      .text(options.data.Name)
                      .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               { alignment: 'center', caption: 'Vehicles', dataField: 'NumberOfAssignedVehicles', cssClass: 'NumberOfAssignedVehicles', dataType: 'number' },
               { alignment: 'center', caption: 'Drivers', dataField: 'NumberOfAssignedDrivers', cssClass: 'NumberOfAssignedDrivers', dataType: 'number' }
            ],
            contentReadyAction: grdReadyAction,
            filterRow: { visible: true },
            groupPanel: { visible: false },
            noDataText: "No Fleets Found",
            pager: { showPageSizeSelector: true, allowedPageSizes: [10, 20, 30] },
            paging: { pageSize: $scope.pageSize, pageIndex: PageIndex },
            rowAlternationEnabled: false,
            selection: { mode: 'single' },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $('#loadingModal').modal({ backdrop: 'static' });                    
                    FleetFactory.getFleetByID(selectedRowsInfo.selectedRowsData[0].Id).success(function (data) {
                        $scope.fleet = data;
                        $scope.refreshAssignedVehiclesGrid();
                        $scope.refreshUnAssignedVehiclesGrid();
                        $scope.refreshAssignedDriversGrid();
                        $scope.refreshUnAssignedDriversGrid();
                        $scope.isFormVisible = true;
                        $scope.isDeleteVisible = true;
                        $scope.isNewFleet = false;
                        ToggleYellowToGreen();
                        $rootScope.pageTitle = "Fleet Management";
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                }
                else {
                    $scope.fleet = angular.copy($scope.newfleet);
                }
            }
        });
    };

    $scope.refreshAssignedVehiclesGrid = function () {
        $scope.isAssignedVehicleSelected = false;

        $('#gridAssignedVehicles').dxDataGrid({
            dataSource: $scope.fleet.AssignedVehicles,
            columns: [
                { caption: 'Vehicle Id', dataField: 'Id', cssClass: 'Id', dataType: 'number', visible: false },                
                {
                    caption: 'Device Id - Name', dataField: 'DeviceId', cssClass: 'DeviceId', dataType: 'string', alignment: 'center',
                    cellTemplate: function (container, options) {
                        var devicedetails = "";
                        if (options.data.DeviceId != 0) devicedetails = devicedetails + options.data.DeviceId + " - ";
                        if (options.data.DeviceName != null) devicedetails = devicedetails + options.data.DeviceName;
                        $('<span />').text(devicedetails).append("</br>").appendTo(container);
                        container.addClass('grid-cell-align-left');
                    },
                    calculateCellValue: function(data){
                        return data.DeviceId + " - " + data.DeviceName;
                    },
                    calculateFilterExpression: function (filterValue, selectedFilterOperation) {
                        return [this.calculateCellValue, selectedFilterOperation || 'contains', filterValue];
                    }
                },
                { alignment: 'center', caption: 'Vehicle No', dataField: 'VehicleNumber', cssClass: 'VehicleNumber', dataType: 'string' },                
                {
                    alignment: 'center', caption: 'License Plate', dataField: 'LicensePlate', cssClass: 'LicensePlate', dataType: 'string',
                    width: 150,
                    cellTemplate: function (container, options) {
                        $('<span />')
                       .text(options.data.LicensePlate)
                       .appendTo(container);
                        container.addClass('grid-cell-align-left');
                    }
                }
            ],            
            filterRow: { visible: true },
            groupPanel: { visible: false },
            height: 470,
            paging: { pageSize: 10 },
            pager: { showPageSizeSelector: false },
            rowAlternationEnabled: false,
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selection: { mode: 'multiple' },
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0) {
                    $scope.isAssignedVehicleSelected = true;
                }
                else {
                    $scope.isAssignedVehicleSelected = false;
                }
            }
        });
    };

    $scope.refreshUnAssignedVehiclesGrid = function () {
        $scope.isUnassignedVehicleSelected = false;        

        $('#gridUnAssignedVehicles').dxDataGrid({
            dataSource: $scope.fleet.UnassignedVehicles,
            columns: [
                { caption: 'Vehicle Id', dataField: 'Id', cssClass: 'Id',  dataType: 'number', visible: false },
                {
                    caption: 'Device Id - Name', dataField: 'DeviceId', cssClass: 'DeviceId', dataType: 'string', alignment: 'center',
                    cellTemplate: function (container, options) {
                        var devicedetails = "";
                        if (options.data.DeviceId != 0) devicedetails = devicedetails + options.data.DeviceId + " - ";
                        if (options.data.DeviceName != null) devicedetails = devicedetails + options.data.DeviceName;
                        $('<span />').text(devicedetails).append("</br>").appendTo(container);
                        container.addClass('grid-cell-align-left');
                    },
                    calculateCellValue: function(data){
                        return data.DeviceId + " - " + data.DeviceName;
                    },
                    calculateFilterExpression: function (filterValue, selectedFilterOperation) {
                        return [this.calculateCellValue, selectedFilterOperation || 'contains', filterValue];
                    }
                },
                { alignment: 'center', caption: 'Vehicle No', dataField: 'VehicleNumber', cssClass: 'VehicleNumber', dataType: 'string' },
                
                {
                    alignment: 'center', caption: 'License Plate', dataField: 'LicensePlate', cssClass: 'LicensePlate', dataType: 'string',
                    width: 150,
                    cellTemplate: function (container, options) {
                        $('<span />')
                       .text(options.data.LicensePlate)
                       .appendTo(container);
                        container.addClass('grid-cell-align-left');
                    }
                }
            ],
            filterRow: { visible: true },
            groupPanel: { visible: false, },
            height: 470,
            paging: { pageSize: 10 },
            pager: { showPageSizeSelector: false },
            rowAlternationEnabled: false,            
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selection: { mode: 'multiple' },
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0) {
                    $scope.isUnassignedVehicleSelected = true;
                }
                else {
                    $scope.isUnassignedVehicleSelected = false;
                }                
            }
        });
    };

    $scope.refreshAssignedDriversGrid = function () {
        $scope.isAssignedDriverSelected = false;
        $('#gridAssignedDrivers').dxDataGrid({
            dataSource: $scope.fleet.AssignedDrivers,
            columns: [
                { alignment: 'center', caption: 'Driver ID', dataField: 'Id', cssClass: 'Id',  dataType: 'number' },
                { alignment: 'center', caption: 'Driver No', dataField: 'Number', cssClass: 'Number', dataType: 'string' },
                {
                    alignment: 'center', caption: 'Driver Name', dataField: 'Name', cssClass: 'Name', dataType: 'string',
                    cellTemplate: function (container, options) {
                        $('<span />')
                       .text(options.data.Name)
                       .appendTo(container);
                        container.addClass('grid-cell-align-left');
                    }
                },
            ],
            filterRow: { visible: true },
            groupPanel: { visible: false, },
            height: 470,
            paging: { pageSize: 10 },
            pager: { showPageSizeSelector: false },
            rowAlternationEnabled: false,
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selection: { mode: 'multiple' },
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0) {
                    $scope.isAssignedDriverSelected = true;
                }
                else {
                    $scope.isAssignedDriverSelected = false;
                }
            }
        });
    };

    $scope.refreshUnAssignedDriversGrid = function () {
        $scope.isUnassignedDriverSelected = false;        

        $('#gridUnAssignedDrivers').dxDataGrid({
            dataSource: $scope.fleet.UnassignedDrivers,
            columns: [
                { alignment: 'center', caption: 'Driver ID', dataField: 'Id', cssClass: 'Id',  dataType: 'number' },
                { alignment: 'center', caption: 'Driver No', dataField: 'Number', cssClass: 'Number', dataType: 'string' },
                {
                    alignment: 'center', caption: 'Driver Name', dataField: 'Name', cssClass: 'Name', dataType: 'string',
                    cellTemplate: function (container, options) {
                        $('<span />')
                       .text(options.data.Name)
                       .appendTo(container);
                        container.addClass('grid-cell-align-left');
                    }
                },
            ],
            filterRow: { visible: true },
            groupPanel: { visible: false, },
            height: 470,
            paging: { pageSize: 10 },
            pager: { showPageSizeSelector: false },
            rowAlternationEnabled: false,
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selection: { mode: 'multiple' },
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0) {
                    $scope.isUnassignedDriverSelected = true;
                }
                else {
                    $scope.isUnassignedDriverSelected = false;
                }                
            }
        });
    };

    //Button click functions
    $scope.addNewFleet = function () {
        $rootScope.pageTitle = "New Fleet Management";
        FleetFactory.getFleetByID(0).success(function (data) {
            $scope.fleet = data;
            $scope.refreshAssignedVehiclesGrid();
            $scope.refreshUnAssignedVehiclesGrid();
            $scope.refreshAssignedDriversGrid();
            $scope.refreshUnAssignedDriversGrid();
            $scope.isFormVisible = true;
            $scope.isDeleteVisible = false;
            $scope.isNewFleet = true;
            ToggleGreenToYellow();
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        });
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            FleetFactory.deleteFleet($scope.fleet.Id).success(function (data) {
                FleetFactory.getFleetList().success(function (data) {
                    var dataGrid = $('#gridFleet').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.fleetList = data;
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex);
                }).error(function () {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Fleet successfully' });
                });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };

    $scope.cancelForm = function () {
        var dataGrid = $('#gridFleet').dxDataGrid('instance');
        dataGrid.clearSelection();
        $scope.isFormVisible = false;
        $scope.fleetForm.$submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.reset = function (type) {
        if (type == 'update') { // get db fleet and set to scope.fleet.
            $('#loadingModal').modal({ backdrop: 'static' });
            FleetFactory.getFleetByID($scope.fleet.Id).success(function (data) {
                $scope.fleet = data;
                $scope.refreshAssignedVehiclesGrid();
                $scope.refreshUnAssignedVehiclesGrid();
                $scope.refreshAssignedDriversGrid();
                $scope.refreshUnAssignedDriversGrid();
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        }
        else {
            angular.copy($scope.newfleet, $scope.fleet);
            $scope.refreshAssignedVehiclesGrid();
            $scope.refreshUnAssignedVehiclesGrid();
            $scope.refreshAssignedDriversGrid();
            $scope.refreshUnAssignedDriversGrid();
        }

        $scope.fleetForm.$setPristine();
        $scope.fleetForm.$submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Fleet details were reset' });
    };

    $scope.submitForm = function () {
        if ($scope.fleetForm.$valid) {
            $scope.saveFleet();
        }
    };

    $scope.saveFleet = function () {
        var pageindex, id;
        $scope.closeModelStateErrors();
        $('#loadingModal').modal({ backdrop: 'static' });
        FleetFactory.saveFleet($scope.fleet).success(function (fleetId) {
            FleetFactory.getFleetList().success(function (data) {
                var dataGrid = $('#gridFleet').dxDataGrid('instance');
                $scope.pageSize = dataGrid.pageSize();
                pageindex = dataGrid.pageIndex();
                $scope.fleetList = data;
                if ($scope.fleet.Id <= 0) {
                    $scope.cancelForm();                    
                }   
                $scope.refreshGrid(pageindex);                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function (data) {
                if ($scope.fleet.Id > 0) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Fleet successfully' });
                }
                else {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Fleet successfully' });
                }
            });
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        }).finally(function () {
            $('#loadingModal').modal('hide');
        });
    };

    // assigning and Unassigning grid items on details panel
    $scope.assignVehicles = function () {
        var dataGrid = $('#gridUnAssignedVehicles').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowsData();
        var i = 0; var len = selectedRows.length;
        for (; i < len; i++) {
            var prd = $scope.filter($scope.fleet.AssignedVehicles, selectedRows[i].Id);
            $scope.fleet.UnassignedVehicles.splice($scope.fleet.UnassignedVehicles.indexOf(selectedRows[i]), 1);
            if (prd == null) {
                $scope.fleet.AssignedVehicles.push(selectedRows[i]);
            }
        }
        $scope.refreshAssignedVehiclesGrid();
        $scope.refreshUnAssignedVehiclesGrid();
        dataGrid.clearSelection();
    };

    $scope.unassignVehicles = function () {
        var dataGrid = $('#gridAssignedVehicles').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowsData();
        var i = 0; var len = selectedRows.length;
        for (; i < len; i++) {
            $scope.fleet.AssignedVehicles.splice($scope.fleet.AssignedVehicles.indexOf(selectedRows[i]), 1);
            $scope.fleet.UnassignedVehicles.push(selectedRows[i]);
        }
        $scope.refreshAssignedVehiclesGrid();
        $scope.refreshUnAssignedVehiclesGrid();
        dataGrid.clearSelection();
    };

    $scope.assignDrivers = function () {
        var dataGrid = $('#gridUnAssignedDrivers').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowsData();
        var i = 0; var len1 = selectedRows.length;
        for (; i < len1; i++) {
            var prd = $scope.filter($scope.fleet.AssignedDrivers, selectedRows[i].Id);
            $scope.fleet.UnassignedDrivers.splice($scope.fleet.UnassignedDrivers.indexOf(selectedRows[i]), 1);
            if (prd == null) {
                $scope.fleet.AssignedDrivers.push(selectedRows[i]);
            }
        }
        $scope.refreshAssignedDriversGrid();
        $scope.refreshUnAssignedDriversGrid();
        dataGrid.clearSelection();
    };

    $scope.unassignDrivers = function () {
        var dataGrid = $('#gridAssignedDrivers').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowsData();
        var i = 0; var len = selectedRows.length;
        for (; i < len; i++) {
            $scope.fleet.AssignedDrivers.splice($scope.fleet.AssignedDrivers.indexOf(selectedRows[i]), 1);
            $scope.fleet.UnassignedDrivers.push(selectedRows[i]);
        }
        $scope.refreshAssignedDriversGrid();
        $scope.refreshUnAssignedDriversGrid();
        dataGrid.clearSelection();
    };

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridFleet', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridFleet', settings.GridMarginHeight);
    };

    collapsibleHeaderClickEvent($scope);

    $scope.filter = function (input, id) {
        var i = 0, len = input.length;
        for (; i < len; i++) {
            if (+input[i].Id == +id) {
                return input[i];
            }
        }
        return null;
    };

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };
});
